// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-form-container {
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
}
.css-m9glnp-MuiPaper-root-MuiDialog-paper {
  background-color: #07070e !important;
  width: 85% !important;
}
.hint {
  color: #fff;
}
.image-preview {
  object-fit: contain;
  width: 100%;
  position: absolute;
  height: 100%;
  color: white;
  text-align: center;
}
/* Css for blinking div wrapper if alarm */
.alarm.true {
  background-color: rgb(80, 31, 31);
  animation: blinker 0.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
/* ______________________ */

.image-preview img {
  height: 100%;
}

.sensor-container {
  position: relative;
}

.dot {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  transition: background-color 0.3s ease;
  border: 3px solid white;
}
.ImagePreviewWrapper {
  border: 1px solid white;
  height: 80vh;
  margin-left: 15px;
  position: relative;
}
.image-preview .blinkingalarm {
  background-color: red;
  animation: blinker 1s linear infinite;
}
.image-preview .normal {
  background-color: green;
}

.labels {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  display: none;
  color: black !important;
  border: 1px solid black;
}
.dot .label {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  display: none;
  color: black !important;
  border: 1px solid black;
}

.dot:hover .labels {
  display: block;
}

.labelForm {
  width: 100%;
}
.imageInput {
  width: 100%;
  text-align: left;
  border: none !important;
  color: white !important;
}

.inputWrapper {
  width: 100%;
  text-align: left;
}

.secondPart input {
  width: 47%;
  margin-right: 8px;
  display: inline;
  background-color: transparent !important;
  border-radius: 0 !important;
  color: #fff !important;
  /* Add any other styles you need */
}

.firstPart input {
  width: 15%;
  margin-right: 8px;
  display: inline;
  background-color: transparent !important;
  border-radius: 0 !important;
  color: #fff !important;
}
.firstPart {
  display: inline;
}
.secondPart {
  display: inline;
}

.inputWrapper label {
  margin-right: 5px;
}
.imageInput input[type="file"] {
  border: none !important;
}

.buttonWrapper {
  width: 100%;
  text-align: right;
  margin-top: 20px;
  margin-left: 10px;
}

.buttonWrapper button {
  border-radius: 0 !important;
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #fff;
  margin-right: 35px;
}

.buttonWrapper button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}
`, "",{"version":3,"sources":["webpack://./src/components/Asset2dImage/configureAsset.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;EAEtB,WAAW;EACX,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA,0CAA0C;AAC1C;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA,2BAA2B;;AAE3B;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;;;;GAIC;AACH","sourcesContent":[".image-form-container {\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n  height: 100%;\n}\n.css-m9glnp-MuiPaper-root-MuiDialog-paper {\n  background-color: #07070e !important;\n  width: 85% !important;\n}\n.hint {\n  color: #fff;\n}\n.image-preview {\n  object-fit: contain;\n  width: 100%;\n  position: absolute;\n  height: 100%;\n  color: white;\n  text-align: center;\n}\n/* Css for blinking div wrapper if alarm */\n.alarm.true {\n  background-color: rgb(80, 31, 31);\n  animation: blinker 0.5s linear infinite;\n}\n\n@keyframes blinker {\n  50% {\n    opacity: 0;\n  }\n}\n/* ______________________ */\n\n.image-preview img {\n  height: 100%;\n}\n\n.sensor-container {\n  position: relative;\n}\n\n.dot {\n  width: 20px;\n  height: 20px;\n  background-color: transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  transition: background-color 0.3s ease;\n  border: 3px solid white;\n}\n.ImagePreviewWrapper {\n  border: 1px solid white;\n  height: 80vh;\n  margin-left: 15px;\n  position: relative;\n}\n.image-preview .blinkingalarm {\n  background-color: red;\n  animation: blinker 1s linear infinite;\n}\n.image-preview .normal {\n  background-color: green;\n}\n\n.labels {\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 5px;\n  border-radius: 5px;\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  display: none;\n  color: black !important;\n  border: 1px solid black;\n}\n.dot .label {\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 5px;\n  border-radius: 5px;\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  display: none;\n  color: black !important;\n  border: 1px solid black;\n}\n\n.dot:hover .labels {\n  display: block;\n}\n\n.labelForm {\n  width: 100%;\n}\n.imageInput {\n  width: 100%;\n  text-align: left;\n  border: none !important;\n  color: white !important;\n}\n\n.inputWrapper {\n  width: 100%;\n  text-align: left;\n}\n\n.secondPart input {\n  width: 47%;\n  margin-right: 8px;\n  display: inline;\n  background-color: transparent !important;\n  border-radius: 0 !important;\n  color: #fff !important;\n  /* Add any other styles you need */\n}\n\n.firstPart input {\n  width: 15%;\n  margin-right: 8px;\n  display: inline;\n  background-color: transparent !important;\n  border-radius: 0 !important;\n  color: #fff !important;\n}\n.firstPart {\n  display: inline;\n}\n.secondPart {\n  display: inline;\n}\n\n.inputWrapper label {\n  margin-right: 5px;\n}\n.imageInput input[type=\"file\"] {\n  border: none !important;\n}\n\n.buttonWrapper {\n  width: 100%;\n  text-align: right;\n  margin-top: 20px;\n  margin-left: 10px;\n}\n\n.buttonWrapper button {\n  border-radius: 0 !important;\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #fff;\n  margin-right: 35px;\n}\n\n.buttonWrapper button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
